import { DatePipe, formatDate, Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { SosReportModel } from 'src/app/modules/reports/sos-reports.model';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

// export const DATE_FORMAT = {
//   parse: {
//     dateInput: "DD-MM-YYYY"
//   },
//   display: {
//     dateInput: "DD/MM/YYYY",
//     monthYearLabel: "MMM YYYY",
//     dateA11yLabel: "DD/MM/YYYY",
//     monthYearA11yLabel: "MMMM YYYY"
//   }
// };

@Component({
  selector: 'app-sos-report',
  templateUrl: './sos-report.component.html',
  styleUrls: ['./sos-report.component.css'],
  // providers: [
  //   {
  //     provide: DateAdapter,
  //     useClass: MomentDateAdapter,
  //     deps: [MAT_DATE_LOCALE]
  //   },
  //   { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
  //   DatePipe
  // ]
})
export class SosReportComponent implements OnInit {

  public matFormSize = '12px';
  public sosForm: FormGroup;

  public tableData = [];
  public noDataFoundEnable: boolean = false;
  public excelData = {};

  public maxDate = new Date();
  public maxEndDate = new Date();

  public showTable: boolean = false;

  public localStorage;
  public errorObject: any = {
    startDate: '',
    endDate: '',
  }

  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  addObj: any ={};

  public formSubmitted: boolean = false;

  public cols = [
    { key: '#', display: '#' ,},
    { key: 'alert', display: 'Alert from', minWidth: '90px', },
    { key: 'name', display: 'Name', headerConfig: { isDefault: true }, minWidth: '90px', },     {
      key: 'regNo', display: 'Vehicle',
      config: {
          isVehicle: true,
      }, minWidth: '90px',
      headerConfig:{ isDefault: true}
  },
    { key: 'date', display: 'SOS time', headerConfig: { isDefault: true }, minWidth: '90px', },
  ];

  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public storage: StorageService,
    public excel: ExcelExportService,
    public comService: CommonServices,
    public router: Router) {
    this.localStorage = this.storage.get('vendorID_orgID');

  }

  ngOnInit(): void {
    this.sosFormLoad();
    this.onSubmit();
  }

  getSOSReports(obj) {
    this.noDataFoundEnable = false;
    this.showTable = false;
    this.tableData = [];
    this.api.getSOSReportList(obj).then((res: any) => {
      if (res && res.data) {
        // this.tableData = res.data;
        this.processPagination(res, obj);
        this.tableData = res['data'].map((data) => {
          return {
            ...data,
            date: this.comService.timestampToDate(data?.gpsTS, 'DMY H:M:S'),
            // date :data.gpsTS ? formatDate(data.gpsTS, 'dd/MMM/yyyy hh:mm:ss a', 'en-In') : '--/--/---- --:--:-- --',
            alert:data?.user === 'employee' ? 'Employee' : data?.user === 'driver' ? 'Driver' : data?.user === 'device' ? '---' : '---',
            name: data?.user === 'employee' ? data.empName  : data?.user === 'driver' ? data.dname : data?.user === 'device' ? '---' : '---'
          };
        });
      }
      setTimeout(() => { this.showTable = true; this.noDataFoundEnable = true }, 100);
    }).catch((err) => {
      console.log(err);
    })
  }

  sosFormLoad() {
    const today = new Date();
    this.sosForm = this.fb.group({
      // vehicle: new FormControl('', [Validators.required]),
      search: new FormControl(''),
      startDate: new FormControl(today.toISOString().substring(0, 10), [Validators.required]),
      endDate: new FormControl(today.toISOString().substring(0, 10), [Validators.required]),
    });
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.sosForm.controls[type].patchValue(x.getTime());
    });
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.sosForm.controls[controlName].hasError(errorName);
  }

  setMaxDate() {
    let t_maxDate = new Date(this.sosForm.controls.startDate.value);

    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 30);

    if (new Date() > t_maxDate) {
      this.maxEndDate = t_maxDate;
    } else {
      this.maxEndDate = new Date();
    }
  }

  validation(data) {
    if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
    let objectKeys = Object.keys(this.errorObject);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid from date';
        }
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.sosForm.value.startDate).getTime(),
      endDate: new Date(this.sosForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {
    this.formSubmitted = true;
    let checkObj = {
      startDate: new Date(this.sosForm.value.startDate).getTime(),
      endDate: new Date(this.sosForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    if (isValid && this.sosForm.status == "VALID") {
      let obj = {
        startDate: new Date(new Date(this.sosForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.sosForm.value.endDate).setHours(23, 59, 59)).getTime(),
        limit: 10,
        page: 1
      }
      if (this.sosForm.value.search != '') obj['search'] = this.sosForm.value.search;
      this.addObj = obj;
      this.getSOSReports(obj);
    }
  }

  async exportToExcel() {
    let data = [];

    const startDate = new Date(this.sosForm.value.startDate + '');
    const endDate = new Date(new Date(this.sosForm.value.endDate + '').setHours(23, 59, 59));

    let rowCount = 2;
    let endCell = 'E';
    let customizedData = [];
    let titleRow = {
      value: ['SOS Reports'],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },

      },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      alignment: {
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: '966462AF' }
      },
    }

    customizedData.push(titleRow);

    rowCount = rowCount + 2;

    let subtitleRow = {
      value: [
        "Start Date     : " + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
        "End Date       : " + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
      ],
      font: { name: 'Corbel', family: 4, size: 12 },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
    }

    customizedData.push(subtitleRow);
    rowCount = rowCount + 1;
    let headerRow =
    {
      value: ['S No', 'Alert from', 'Name', 'Vehicle', 'SOS time'],
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      },
      font: { bold: true },
      border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    }
    customizedData.push(headerRow);


    for (let i = 0; i < this.tableData.length; i++) {
      let item = this.tableData[i];
      try {
        let res = {
          value: [
            i + 1,
            item?.user === 'employee' ? 'Employee' : item?.user === 'driver' ? 'Driver' : item?.user === 'device' ? '---' : '---',
            item?.user === 'employee' ? item.empName  : item?.user === 'driver' ? item.dname : item?.user === 'device' ? '---' : '---',
            item.regNo ? item.regNo.toUpperCase() : '---',
            item.gpsTS ? this.comService.timestampToDate(item?.gpsTS, 'DMY H:M:S') : '--/--/---- --:--:-- --',
          ]
        };
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      customizedData = [...customizedData, ...data];

      if (this.excelData['SOS'] == undefined) {
        this.excelData['SOS'] = {};
      }

      this.excelData['SOS'] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 15 }, { colNo: 3, width: 20 }, { colNo: 4, width: 15 }, { colNo: 5, width: 25 }]
        }
      }

      const chunk: any = await this.comService.chunkObject(this.excelData, 50);
      for (let i = 0; i < chunk.length; i++) {
        this.excel.generateExcel(chunk[i], 'SOS_' + 'Reports' +  '_' +this.comService.timestampToDate(new Date().getTime(),'DMY' ) + '.xlsx');
      }
    }

  }

  pagination(data) {
    this.addObj['page'] = data['page'],
     this.addObj['limit'] = data['limit'];
     this.getSOSReports(this.addObj)
   }
   processPagination(data, req) {
     this.showTable = false;
     this.paginationData = {
         page: req.page,
         limit: req.limit,
         totalPage: this.getTotalCount(data.totCnt, req.limit),
     }
     this.showTable = true;
 }
 getTotalCount(total, limit) {
   let result: any = 1;
   if (total / limit > 0) {
       result = total / limit;
       if (total % limit > 0) result++;
   }
   return Math.floor(result);
 }
}

